import { Controller } from "@hotwired/stimulus";

import { subscribeUnread } from "../lib/unread.js";

/**
 * Счётчик непрочитанного.
 *
 * Один контроллер на уведомления и на сообщения: различались они только
 * адресом, интервалом и именем поля в ответе — теперь это значения.
 *
 * Сам опрос живёт в `lib/unread.js`: одно и то же число показывают сразу
 * несколько значков (шапка, полоса кабинета, нижняя панель), и запрос на всех
 * них должен быть один.
 */
export default class extends Controller {
  static values = {
    url: String,
    key: { type: String, default: "count" },
    interval: { type: Number, default: 30000 },
  };

  connect() {
    if (!this.hasUrlValue) return;

    this.unsubscribe = subscribeUnread(
      this.urlValue,
      this.keyValue,
      this.intervalValue,
      (count) => this.render(count),
    );
  }

  disconnect() {
    this.unsubscribe?.();
  }

  /** Больше 99 не показываем — плашка рассчитана на два знака. */
  render(count) {
    this.element.classList.toggle("u-hidden", count === 0);
    this.element.textContent = count === 0 ? "" : count > 99 ? "99+" : String(count);
  }
}
